import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { saveWorkingProjectByFields } from '@/store/slices/project';
import { Registration } from '@/types/registration.types';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import useComputedRegistrationSettings from '../../hooks/use-computed-registration-settings';
import { selectIsSavingWorkingProject } from '@/store/slices/project/selectors';
import Switch from '@ui/switch/switch';

export default function EmailConfirmationToggle() {
  const dispatch = useAppDispatch();
  const { ticketingOn, registrationSettings, passwordGateEnabled } = useComputedRegistrationSettings();
  const savingWorkingProject = useAppSelector(selectIsSavingWorkingProject);

  const sendEmailConfirmation = registrationSettings?.sendEmailConfirmation;
  const confirmationRequired = registrationSettings?.registrationConfirmation;

  const toggleSendEmailConfirmation = (value: boolean, on: boolean) => {
    if (!registrationSettings) return;
    const updatedSettings: Registration = {
      ...registrationSettings,
      sendEmailConfirmation: on,
    };

    dispatch(saveWorkingProjectByFields({ registration_settings: updatedSettings }));
  };

  return (
    <Container design="GlobalCont1" borderRadius="12px" padding="16px" className="flex ai-center jc-space-between">
      <Text tag="h6" className="H6" design="GlobalIcoText1">
        Send Confirmation Email
      </Text>
      <Switch
        value={!!sendEmailConfirmation}
        on={!!sendEmailConfirmation}
        onClick={toggleSendEmailConfirmation}
        disabled={
          (sendEmailConfirmation && (confirmationRequired || ticketingOn)) ||
          passwordGateEnabled ||
          !registrationSettings ||
          savingWorkingProject
        }
      />
    </Container>
  );
}
